module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/athor23-33912d60c3b98ff00f5a3c7e27f55968.jpg";